import { render } from "./clientMessage.vue?vue&type=template&id=43893aef&scoped=true"
import script from "./clientMessage.vue?vue&type=script&lang=js"
export * from "./clientMessage.vue?vue&type=script&lang=js"

import "./clientMessage.vue?vue&type=style&index=0&id=43893aef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43893aef"]])

export default __exports__